<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12">
    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-10 p-0">
      <!-- Container: Container 4 -->
      <div
        class="rappider-container container-4 col-12 hidden-mw480 p-0 navbar-1-height"
      >
        <!-- Container: Container 5 -->
        <div
          class="rappider-container container-5 col-3 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Image 1 -->
            <rappider-image
              [source]="image_1.source"
              [alternateText]="image_1.alternateText"
              [placeholder]="image_1.placeholder"
              [disablePreview]="image_1.disablePreview"
              [borderSettings]="image_1.borderSettings"
              [shadowSettings]="image_1.shadowSettings"
              [paddingSettings]="image_1.paddingSettings"
              [marginSettings]="image_1.marginSettings"
              [customSizeSettings]="image_1.customSizeSettings"
            >
            </rappider-image>
          </div>
        </div>

        <!-- Container: Container 6 -->
        <div
          class="rappider-container container-6 col-6 container-spacing-settings"
        >
          <div class="rappider-component select-height">
            <!-- Component: Select 2 -->
            <rappider-select
              [grouppedOptions]="select_2.grouppedOptions"
              [placeholder]="select_2.placeholder"
              [invalidConfigText]="select_2.invalidConfigText"
              [disabled]="select_2.disabled"
              [buttons]="select_2.buttons"
              [dropdownMatchSelectWidth]="select_2.dropdownMatchSelectWidth"
              [dropdownClassName]="select_2.dropdownClassName"
              [cssStyle]="select_2.cssStyle"
              [cssClass]="select_2.cssClass"
              [borderSettings]="select_2.borderSettings"
              [sizeSettings]="select_2.sizeSettings"
              [colorSettings]="select_2.colorSettings"
              [boxShadowSettings]="select_2.boxShadowSettings"
              [paddingSettings]="select_2.paddingSettings"
              [marginSettings]="select_2.marginSettings"
              [size]="select_2.size"
              [settings]="select_2.settings"
              [options]="select_2.options"
            >
            </rappider-select>
          </div>

          <div class="rappider-component input-settings input-button">
            <!-- Component: Input Group 3 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_3.prefixIcon"
              [suffixIcon]="inputGroup_3.suffixIcon"
              [prefixButton]="inputGroup_3.prefixButton"
              [suffixButton]="inputGroup_3.suffixButton"
              [textbox]="inputGroup_3.textbox"
              [prefixText]="inputGroup_3.prefixText"
              [suffixText]="inputGroup_3.suffixText"
            >
            </rappider-input-group>
          </div>
        </div>

        <!-- Container: Container 7 -->
        <div
          class="rappider-container container-7 col-2 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Icon 4 -->
            <rappider-icon
              [name]="icon_4.name"
              [color]="icon_4.color"
              [size]="icon_4.size"
              [type]="icon_4.type"
              [theme]="icon_4.theme"
              [animation]="icon_4.animation"
              [style]="icon_4.style"
              [secondColor]="icon_4.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 5 -->
            <rappider-button
              [text]="button_5.text"
              [type]="button_5.type"
              [shape]="button_5.shape"
              [size]="button_5.size"
              [colorType]="button_5.colorType"
              [icon]="button_5.icon"
              [iconPlacement]="button_5.iconPlacement"
              [transparent]="button_5.transparent"
              [loading]="button_5.loading"
              [block]="button_5.block"
              [disabled]="button_5.disabled"
              [key]="button_5.key"
              [emitWithoutPopconfirm]="button_5.emitWithoutPopconfirm"
              [popconfirmTitle]="button_5.popconfirmTitle"
              [borderSettings]="button_5.borderSettings"
              [marginSettings]="button_5.marginSettings"
              [paddingSettings]="button_5.paddingSettings"
              [shadowSettings]="button_5.shadowSettings"
              [customColorSettings]="button_5.customColorSettings"
              [customSizeSettings]="button_5.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 6 -->
            <rappider-button
              [text]="button_6.text"
              [type]="button_6.type"
              [shape]="button_6.shape"
              [size]="button_6.size"
              [colorType]="button_6.colorType"
              [icon]="button_6.icon"
              [iconPlacement]="button_6.iconPlacement"
              [transparent]="button_6.transparent"
              [loading]="button_6.loading"
              [block]="button_6.block"
              [disabled]="button_6.disabled"
              [key]="button_6.key"
              [emitWithoutPopconfirm]="button_6.emitWithoutPopconfirm"
              [popconfirmTitle]="button_6.popconfirmTitle"
              [borderSettings]="button_6.borderSettings"
              [marginSettings]="button_6.marginSettings"
              [paddingSettings]="button_6.paddingSettings"
              [shadowSettings]="button_6.shadowSettings"
              [customColorSettings]="button_6.customColorSettings"
              [customSizeSettings]="button_6.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>
      </div>

      <!-- Container: Container 8 -->
      <div
        class="rappider-container container-8 col-12 container-spacing-settings mobile-navbar-bg mobile-navbar-settings"
      >
        <!-- Container: Container 9 -->
        <div
          class="rappider-container container-9 col-12 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Image 7 -->
            <rappider-image
              [source]="image_7.source"
              [alternateText]="image_7.alternateText"
              [placeholder]="image_7.placeholder"
              [disablePreview]="image_7.disablePreview"
              [borderSettings]="image_7.borderSettings"
              [shadowSettings]="image_7.shadowSettings"
              [paddingSettings]="image_7.paddingSettings"
              [marginSettings]="image_7.marginSettings"
              [customSizeSettings]="image_7.customSizeSettings"
            >
            </rappider-image>
          </div>

          <!-- Container: Container 10 -->
          <div
            class="rappider-container container-10 col-1 container-spacing-settings"
          >
            <div class="rappider-component">
              <!-- Component: Cart Preview  8 -->
              <rappider-cart-preview
                [cartItem]="cartPreview_8.cartItem"
                [footer]="cartPreview_8.footer"
                [footerContent]="cartPreview_8.footerContent"
                [buttons]="cartPreview_8.buttons"
                [dropdownButton]="cartPreview_8.dropdownButton"
                [placement]="cartPreview_8.placement"
                [triggerType]="cartPreview_8.triggerType"
              >
              </rappider-cart-preview>
            </div>

            <div class="rappider-component">
              <!-- Component: Icon 9 -->
              <rappider-icon
                [name]="icon_9.name"
                [color]="icon_9.color"
                [size]="icon_9.size"
                [type]="icon_9.type"
                [theme]="icon_9.theme"
                [animation]="icon_9.animation"
                [style]="icon_9.style"
                [secondColor]="icon_9.secondColor"
              >
              </rappider-icon>
            </div>
          </div>
        </div>

        <!-- Container: Container 11 -->
        <div
          class="rappider-container container-11 col-12 container-spacing-settings navbar-mobile-bg"
        >
          <div class="rappider-component">
            <!-- Component: Input Group 10 -->
            <rappider-input-group
              [prefixIcon]="inputGroup_10.prefixIcon"
              [suffixIcon]="inputGroup_10.suffixIcon"
              [prefixButton]="inputGroup_10.prefixButton"
              [suffixButton]="inputGroup_10.suffixButton"
              [textbox]="inputGroup_10.textbox"
              [prefixText]="inputGroup_10.prefixText"
              [suffixText]="inputGroup_10.suffixText"
            >
            </rappider-input-group>
          </div>
        </div>
      </div>

      <!-- Container: Container 12 -->
      <div
        class="rappider-container container-12 col-12 container-spacing-settings hidden-mw480"
      >
        <!-- Container: Container 13 -->
        <div
          class="rappider-container container-13 col-3 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Dropdown Menu 11 -->
            <rappider-dropdown-menu
              [icon]="dropdownMenu_11.icon"
              [placement]="dropdownMenu_11.placement"
              [triggerType]="dropdownMenu_11.triggerType"
              [items]="dropdownMenu_11.items"
              [label]="dropdownMenu_11.label"
              [labelMode]="dropdownMenu_11.labelMode"
            >
            </rappider-dropdown-menu>
          </div>
        </div>

        <!-- Container: Container 14 -->
        <div
          class="rappider-container container-14 col-5 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Menu 12 -->
            <rappider-menu
              [config]="menu_12.config"
              [isCollapsed]="menu_12.isCollapsed"
              [paddingValue]="menu_12.paddingValue"
              [menuPlacement]="menu_12.menuPlacement"
            >
            </rappider-menu>
          </div>
        </div>

        <!-- Container: Container 15 -->
        <div
          class="rappider-container container-15 col-4 container-spacing-settings"
        >
          <div class="rappider-component">
            <!-- Component: Icon 13 -->
            <rappider-icon
              [name]="icon_13.name"
              [color]="icon_13.color"
              [size]="icon_13.size"
              [type]="icon_13.type"
              [theme]="icon_13.theme"
              [animation]="icon_13.animation"
              [style]="icon_13.style"
              [secondColor]="icon_13.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Text 14 -->
            <rappider-text
              [textMode]="text_14.textMode"
              [text]="text_14.text"
              [content]="text_14.content"
              [typography]="text_14.typography"
              [colorSettings]="text_14.colorSettings"
            >
            </rappider-text>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 16 -->
  <div class="rappider-container container-16 col-12 flex-wrap-responsive">
    <!-- Container: Container 17 -->
    <div class="rappider-container container-17 col-12">
      <div class="rappider-component">
        <!-- Component: Divider 15 -->
        <rappider-divider
          [style]="divider_15.style"
          [type]="divider_15.type"
          [text]="divider_15.text"
          [textPlacement]="divider_15.textPlacement"
          [dividerWidth]="divider_15.dividerWidth"
          [dividerColor]="divider_15.dividerColor"
        >
        </rappider-divider>
      </div>
    </div>

    <!-- Container: Container 18 -->
    <div
      class="rappider-container container-18 col-10 container-width-100-mw480"
    >
      <!-- Container: Container 19 -->
      <div
        class="rappider-container container-19 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 16 -->
          <rappider-heading
            [content]="heading_16.content"
            [type]="heading_16.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 17 -->
          <rappider-button
            [text]="button_17.text"
            [type]="button_17.type"
            [shape]="button_17.shape"
            [size]="button_17.size"
            [colorType]="button_17.colorType"
            [icon]="button_17.icon"
            [iconPlacement]="button_17.iconPlacement"
            [transparent]="button_17.transparent"
            [loading]="button_17.loading"
            [block]="button_17.block"
            [disabled]="button_17.disabled"
            [key]="button_17.key"
            [emitWithoutPopconfirm]="button_17.emitWithoutPopconfirm"
            [popconfirmTitle]="button_17.popconfirmTitle"
            [borderSettings]="button_17.borderSettings"
            [marginSettings]="button_17.marginSettings"
            [paddingSettings]="button_17.paddingSettings"
            [shadowSettings]="button_17.shadowSettings"
            [customColorSettings]="button_17.customColorSettings"
            [customSizeSettings]="button_17.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 18 -->
          <rappider-button
            [text]="button_18.text"
            [type]="button_18.type"
            [shape]="button_18.shape"
            [size]="button_18.size"
            [colorType]="button_18.colorType"
            [icon]="button_18.icon"
            [iconPlacement]="button_18.iconPlacement"
            [transparent]="button_18.transparent"
            [loading]="button_18.loading"
            [block]="button_18.block"
            [disabled]="button_18.disabled"
            [key]="button_18.key"
            [emitWithoutPopconfirm]="button_18.emitWithoutPopconfirm"
            [popconfirmTitle]="button_18.popconfirmTitle"
            [borderSettings]="button_18.borderSettings"
            [marginSettings]="button_18.marginSettings"
            [paddingSettings]="button_18.paddingSettings"
            [shadowSettings]="button_18.shadowSettings"
            [customColorSettings]="button_18.customColorSettings"
            [customSizeSettings]="button_18.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 19 -->
          <rappider-button
            [text]="button_19.text"
            [type]="button_19.type"
            [shape]="button_19.shape"
            [size]="button_19.size"
            [colorType]="button_19.colorType"
            [icon]="button_19.icon"
            [iconPlacement]="button_19.iconPlacement"
            [transparent]="button_19.transparent"
            [loading]="button_19.loading"
            [block]="button_19.block"
            [disabled]="button_19.disabled"
            [key]="button_19.key"
            [emitWithoutPopconfirm]="button_19.emitWithoutPopconfirm"
            [popconfirmTitle]="button_19.popconfirmTitle"
            [borderSettings]="button_19.borderSettings"
            [marginSettings]="button_19.marginSettings"
            [paddingSettings]="button_19.paddingSettings"
            [shadowSettings]="button_19.shadowSettings"
            [customColorSettings]="button_19.customColorSettings"
            [customSizeSettings]="button_19.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 20 -->
          <rappider-button
            [text]="button_20.text"
            [type]="button_20.type"
            [shape]="button_20.shape"
            [size]="button_20.size"
            [colorType]="button_20.colorType"
            [icon]="button_20.icon"
            [iconPlacement]="button_20.iconPlacement"
            [transparent]="button_20.transparent"
            [loading]="button_20.loading"
            [block]="button_20.block"
            [disabled]="button_20.disabled"
            [key]="button_20.key"
            [emitWithoutPopconfirm]="button_20.emitWithoutPopconfirm"
            [popconfirmTitle]="button_20.popconfirmTitle"
            [borderSettings]="button_20.borderSettings"
            [marginSettings]="button_20.marginSettings"
            [paddingSettings]="button_20.paddingSettings"
            [shadowSettings]="button_20.shadowSettings"
            [customColorSettings]="button_20.customColorSettings"
            [customSizeSettings]="button_20.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 21 -->
          <rappider-button
            [text]="button_21.text"
            [type]="button_21.type"
            [shape]="button_21.shape"
            [size]="button_21.size"
            [colorType]="button_21.colorType"
            [icon]="button_21.icon"
            [iconPlacement]="button_21.iconPlacement"
            [transparent]="button_21.transparent"
            [loading]="button_21.loading"
            [block]="button_21.block"
            [disabled]="button_21.disabled"
            [key]="button_21.key"
            [emitWithoutPopconfirm]="button_21.emitWithoutPopconfirm"
            [popconfirmTitle]="button_21.popconfirmTitle"
            [borderSettings]="button_21.borderSettings"
            [marginSettings]="button_21.marginSettings"
            [paddingSettings]="button_21.paddingSettings"
            [shadowSettings]="button_21.shadowSettings"
            [customColorSettings]="button_21.customColorSettings"
            [customSizeSettings]="button_21.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 20 -->
      <div
        class="rappider-container container-20 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 22 -->
          <rappider-heading
            [content]="heading_22.content"
            [type]="heading_22.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 23 -->
          <rappider-button
            [text]="button_23.text"
            [type]="button_23.type"
            [shape]="button_23.shape"
            [size]="button_23.size"
            [colorType]="button_23.colorType"
            [icon]="button_23.icon"
            [iconPlacement]="button_23.iconPlacement"
            [transparent]="button_23.transparent"
            [loading]="button_23.loading"
            [block]="button_23.block"
            [disabled]="button_23.disabled"
            [key]="button_23.key"
            [emitWithoutPopconfirm]="button_23.emitWithoutPopconfirm"
            [popconfirmTitle]="button_23.popconfirmTitle"
            [borderSettings]="button_23.borderSettings"
            [marginSettings]="button_23.marginSettings"
            [paddingSettings]="button_23.paddingSettings"
            [shadowSettings]="button_23.shadowSettings"
            [customColorSettings]="button_23.customColorSettings"
            [customSizeSettings]="button_23.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 24 -->
          <rappider-button
            [text]="button_24.text"
            [type]="button_24.type"
            [shape]="button_24.shape"
            [size]="button_24.size"
            [colorType]="button_24.colorType"
            [icon]="button_24.icon"
            [iconPlacement]="button_24.iconPlacement"
            [transparent]="button_24.transparent"
            [loading]="button_24.loading"
            [block]="button_24.block"
            [disabled]="button_24.disabled"
            [key]="button_24.key"
            [emitWithoutPopconfirm]="button_24.emitWithoutPopconfirm"
            [popconfirmTitle]="button_24.popconfirmTitle"
            [borderSettings]="button_24.borderSettings"
            [marginSettings]="button_24.marginSettings"
            [paddingSettings]="button_24.paddingSettings"
            [shadowSettings]="button_24.shadowSettings"
            [customColorSettings]="button_24.customColorSettings"
            [customSizeSettings]="button_24.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 25 -->
          <rappider-button
            [text]="button_25.text"
            [type]="button_25.type"
            [shape]="button_25.shape"
            [size]="button_25.size"
            [colorType]="button_25.colorType"
            [icon]="button_25.icon"
            [iconPlacement]="button_25.iconPlacement"
            [transparent]="button_25.transparent"
            [loading]="button_25.loading"
            [block]="button_25.block"
            [disabled]="button_25.disabled"
            [key]="button_25.key"
            [emitWithoutPopconfirm]="button_25.emitWithoutPopconfirm"
            [popconfirmTitle]="button_25.popconfirmTitle"
            [borderSettings]="button_25.borderSettings"
            [marginSettings]="button_25.marginSettings"
            [paddingSettings]="button_25.paddingSettings"
            [shadowSettings]="button_25.shadowSettings"
            [customColorSettings]="button_25.customColorSettings"
            [customSizeSettings]="button_25.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 26 -->
          <rappider-button
            [text]="button_26.text"
            [type]="button_26.type"
            [shape]="button_26.shape"
            [size]="button_26.size"
            [colorType]="button_26.colorType"
            [icon]="button_26.icon"
            [iconPlacement]="button_26.iconPlacement"
            [transparent]="button_26.transparent"
            [loading]="button_26.loading"
            [block]="button_26.block"
            [disabled]="button_26.disabled"
            [key]="button_26.key"
            [emitWithoutPopconfirm]="button_26.emitWithoutPopconfirm"
            [popconfirmTitle]="button_26.popconfirmTitle"
            [borderSettings]="button_26.borderSettings"
            [marginSettings]="button_26.marginSettings"
            [paddingSettings]="button_26.paddingSettings"
            [shadowSettings]="button_26.shadowSettings"
            [customColorSettings]="button_26.customColorSettings"
            [customSizeSettings]="button_26.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 21 -->
      <div
        class="rappider-container container-21 col-2 footer-container-settings"
      >
        <div class="rappider-component">
          <!-- Component: Heading 27 -->
          <rappider-heading
            [content]="heading_27.content"
            [type]="heading_27.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 28 -->
          <rappider-button
            [text]="button_28.text"
            [type]="button_28.type"
            [shape]="button_28.shape"
            [size]="button_28.size"
            [colorType]="button_28.colorType"
            [icon]="button_28.icon"
            [iconPlacement]="button_28.iconPlacement"
            [transparent]="button_28.transparent"
            [loading]="button_28.loading"
            [block]="button_28.block"
            [disabled]="button_28.disabled"
            [key]="button_28.key"
            [emitWithoutPopconfirm]="button_28.emitWithoutPopconfirm"
            [popconfirmTitle]="button_28.popconfirmTitle"
            [borderSettings]="button_28.borderSettings"
            [marginSettings]="button_28.marginSettings"
            [paddingSettings]="button_28.paddingSettings"
            [shadowSettings]="button_28.shadowSettings"
            [customColorSettings]="button_28.customColorSettings"
            [customSizeSettings]="button_28.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 29 -->
          <rappider-button
            [text]="button_29.text"
            [type]="button_29.type"
            [shape]="button_29.shape"
            [size]="button_29.size"
            [colorType]="button_29.colorType"
            [icon]="button_29.icon"
            [iconPlacement]="button_29.iconPlacement"
            [transparent]="button_29.transparent"
            [loading]="button_29.loading"
            [block]="button_29.block"
            [disabled]="button_29.disabled"
            [key]="button_29.key"
            [emitWithoutPopconfirm]="button_29.emitWithoutPopconfirm"
            [popconfirmTitle]="button_29.popconfirmTitle"
            [borderSettings]="button_29.borderSettings"
            [marginSettings]="button_29.marginSettings"
            [paddingSettings]="button_29.paddingSettings"
            [shadowSettings]="button_29.shadowSettings"
            [customColorSettings]="button_29.customColorSettings"
            [customSizeSettings]="button_29.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 30 -->
          <rappider-button
            [text]="button_30.text"
            [type]="button_30.type"
            [shape]="button_30.shape"
            [size]="button_30.size"
            [colorType]="button_30.colorType"
            [icon]="button_30.icon"
            [iconPlacement]="button_30.iconPlacement"
            [transparent]="button_30.transparent"
            [loading]="button_30.loading"
            [block]="button_30.block"
            [disabled]="button_30.disabled"
            [key]="button_30.key"
            [emitWithoutPopconfirm]="button_30.emitWithoutPopconfirm"
            [popconfirmTitle]="button_30.popconfirmTitle"
            [borderSettings]="button_30.borderSettings"
            [marginSettings]="button_30.marginSettings"
            [paddingSettings]="button_30.paddingSettings"
            [shadowSettings]="button_30.shadowSettings"
            [customColorSettings]="button_30.customColorSettings"
            [customSizeSettings]="button_30.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 31 -->
          <rappider-button
            [text]="button_31.text"
            [type]="button_31.type"
            [shape]="button_31.shape"
            [size]="button_31.size"
            [colorType]="button_31.colorType"
            [icon]="button_31.icon"
            [iconPlacement]="button_31.iconPlacement"
            [transparent]="button_31.transparent"
            [loading]="button_31.loading"
            [block]="button_31.block"
            [disabled]="button_31.disabled"
            [key]="button_31.key"
            [emitWithoutPopconfirm]="button_31.emitWithoutPopconfirm"
            [popconfirmTitle]="button_31.popconfirmTitle"
            [borderSettings]="button_31.borderSettings"
            [marginSettings]="button_31.marginSettings"
            [paddingSettings]="button_31.paddingSettings"
            [shadowSettings]="button_31.shadowSettings"
            [customColorSettings]="button_31.customColorSettings"
            [customSizeSettings]="button_31.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 22 -->
      <div
        class="rappider-container container-22 col-3 container-width-100-mw480"
      >
        <div class="rappider-component">
          <!-- Component: Textbox 32 -->
          <rappider-textbox
            [placeholder]="textbox_32.placeholder"
            [type]="textbox_32.type"
            [mask]="textbox_32.mask"
            [maskGuide]="textbox_32.maskGuide"
            [cssStyle]="textbox_32.cssStyle"
            [cssClass]="textbox_32.cssClass"
            [disabled]="textbox_32.disabled"
            [mentionSupported]="textbox_32.mentionSupported"
            [mentionPrefix]="textbox_32.mentionPrefix"
            [mentionValues]="textbox_32.mentionValues"
            [borderSettings]="textbox_32.borderSettings"
            [sizeSettings]="textbox_32.sizeSettings"
            [colorSettings]="textbox_32.colorSettings"
            [boxShadowSettings]="textbox_32.boxShadowSettings"
            [paddingSettings]="textbox_32.paddingSettings"
            [marginSettings]="textbox_32.marginSettings"
            [size]="textbox_32.size"
          >
          </rappider-textbox>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 33 -->
          <rappider-button
            [text]="button_33.text"
            [type]="button_33.type"
            [shape]="button_33.shape"
            [size]="button_33.size"
            [colorType]="button_33.colorType"
            [icon]="button_33.icon"
            [iconPlacement]="button_33.iconPlacement"
            [transparent]="button_33.transparent"
            [loading]="button_33.loading"
            [block]="button_33.block"
            [disabled]="button_33.disabled"
            [key]="button_33.key"
            [emitWithoutPopconfirm]="button_33.emitWithoutPopconfirm"
            [popconfirmTitle]="button_33.popconfirmTitle"
            [borderSettings]="button_33.borderSettings"
            [marginSettings]="button_33.marginSettings"
            [paddingSettings]="button_33.paddingSettings"
            [shadowSettings]="button_33.shadowSettings"
            [customColorSettings]="button_33.customColorSettings"
            [customSizeSettings]="button_33.customSizeSettings"
          >
          </rappider-button>
        </div>

        <!-- Container: Container 23 -->
        <div
          class="rappider-container container-23 col-8 container-width-100-mw480"
        >
          <div class="rappider-component">
            <!-- Component: Icon 34 -->
            <rappider-icon
              [name]="icon_34.name"
              [color]="icon_34.color"
              [size]="icon_34.size"
              [type]="icon_34.type"
              [theme]="icon_34.theme"
              [animation]="icon_34.animation"
              [style]="icon_34.style"
              [secondColor]="icon_34.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 35 -->
            <rappider-icon
              [name]="icon_35.name"
              [color]="icon_35.color"
              [size]="icon_35.size"
              [type]="icon_35.type"
              [theme]="icon_35.theme"
              [animation]="icon_35.animation"
              [style]="icon_35.style"
              [secondColor]="icon_35.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 36 -->
            <rappider-icon
              [name]="icon_36.name"
              [color]="icon_36.color"
              [size]="icon_36.size"
              [type]="icon_36.type"
              [theme]="icon_36.theme"
              [animation]="icon_36.animation"
              [style]="icon_36.style"
              [secondColor]="icon_36.secondColor"
            >
            </rappider-icon>
          </div>

          <div class="rappider-component">
            <!-- Component: Icon 37 -->
            <rappider-icon
              [name]="icon_37.name"
              [color]="icon_37.color"
              [size]="icon_37.size"
              [type]="icon_37.type"
              [theme]="icon_37.theme"
              [animation]="icon_37.animation"
              [style]="icon_37.style"
              [secondColor]="icon_37.secondColor"
            >
            </rappider-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 24 -->
    <div class="rappider-container container-24 col-10">
      <!-- Container: Container 25 -->
      <div class="rappider-container container-25 col-6">
        <div class="rappider-component">
          <!-- Component: Text 38 -->
          <rappider-text
            [textMode]="text_38.textMode"
            [text]="text_38.text"
            [content]="text_38.content"
            [typography]="text_38.typography"
            [colorSettings]="text_38.colorSettings"
          >
          </rappider-text>
        </div>
      </div>

      <!-- Container: Container 26 -->
      <div class="rappider-container container-26 col-6">
        <div class="rappider-component">
          <!-- Component: Text 39 -->
          <rappider-text
            [textMode]="text_39.textMode"
            [text]="text_39.text"
            [content]="text_39.content"
            [typography]="text_39.typography"
            [colorSettings]="text_39.colorSettings"
          >
          </rappider-text>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 40 -->
          <rappider-image
            [source]="image_40.source"
            [alternateText]="image_40.alternateText"
            [placeholder]="image_40.placeholder"
            [disablePreview]="image_40.disablePreview"
            [borderSettings]="image_40.borderSettings"
            [shadowSettings]="image_40.shadowSettings"
            [paddingSettings]="image_40.paddingSettings"
            [marginSettings]="image_40.marginSettings"
            [customSizeSettings]="image_40.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 41 -->
          <rappider-image
            [source]="image_41.source"
            [alternateText]="image_41.alternateText"
            [placeholder]="image_41.placeholder"
            [disablePreview]="image_41.disablePreview"
            [borderSettings]="image_41.borderSettings"
            [shadowSettings]="image_41.shadowSettings"
            [paddingSettings]="image_41.paddingSettings"
            [marginSettings]="image_41.marginSettings"
            [customSizeSettings]="image_41.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 42 -->
          <rappider-image
            [source]="image_42.source"
            [alternateText]="image_42.alternateText"
            [placeholder]="image_42.placeholder"
            [disablePreview]="image_42.disablePreview"
            [borderSettings]="image_42.borderSettings"
            [shadowSettings]="image_42.shadowSettings"
            [paddingSettings]="image_42.paddingSettings"
            [marginSettings]="image_42.marginSettings"
            [customSizeSettings]="image_42.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 43 -->
          <rappider-image
            [source]="image_43.source"
            [alternateText]="image_43.alternateText"
            [placeholder]="image_43.placeholder"
            [disablePreview]="image_43.disablePreview"
            [borderSettings]="image_43.borderSettings"
            [shadowSettings]="image_43.shadowSettings"
            [paddingSettings]="image_43.paddingSettings"
            [marginSettings]="image_43.marginSettings"
            [customSizeSettings]="image_43.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 44 -->
          <rappider-image
            [source]="image_44.source"
            [alternateText]="image_44.alternateText"
            [placeholder]="image_44.placeholder"
            [disablePreview]="image_44.disablePreview"
            [borderSettings]="image_44.borderSettings"
            [shadowSettings]="image_44.shadowSettings"
            [paddingSettings]="image_44.paddingSettings"
            [marginSettings]="image_44.marginSettings"
            [customSizeSettings]="image_44.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
